import App from 'app/app.js';

function LtInfoButtonDirective() {
  return {
    restrict: 'E',
    scope: {
      content: '@',
      placement: '@'
    },
    template:
      '<div class="lt-info-button">' +
      '    <a data-id="text_link" class="mara-dark-grey weight-600 no-underline"' +
      '        popover-placement="placement" popover-trigger="\'outsideClick\'"' +
      '        uib-popover-html="content" popover-class="popover-content">' +
      '        <lt-icon name="fa-sharp-regular-info-circle" class="f4 fa-info-circle mara-blue"></lt-icon>' +
      '    </a>' +
      '</div>',
    link: function (scope) {
      scope.placement = scope.placement || 'auto';
    }
  };
}

App.directive('ltInfoButton', [LtInfoButtonDirective]);
